import { useTranslation } from 'react-i18next';
import { ErrorBoundary as ReactErrorBoundary, useErrorBoundary } from 'react-error-boundary';
import AppBodyComponent from './AppBodyComponent';
import { Button } from 'primereact/button';

// Error fallback UI component
const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation('commom');

  return (
    <div>
        <div style={{ padding: '24px' }}>
            <h3>{t('general_error_message')}</h3>
            <Button onClick={resetErrorBoundary}>
            <h5>{t('general_error_retry')}</h5>
            </Button>
            <a href="/"><h5>{t('general_error_go_home')}</h5></a>
        </div>
    </div>
  );
};

// Main ErrorBoundary wrapper
export const ErrorBoundary = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => console.error('Error caught:', error)}
    >
      {children}
    </ReactErrorBoundary>
  );
};

// Custom hook to manually trigger errors (e.g., in async code)
export const useThrowError = () => {
  const { showBoundary } = useErrorBoundary();
  return showBoundary;
};

export default ErrorBoundary;